var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgFb = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "currentColor", d: "M12 4c-4.418 0-8 3.6-8 8.041a8.023 8.023 0 0 0 6.804 7.942v-5.81h-1.98v-2.115h1.98v-1.406c0-2.329 1.129-3.351 3.054-3.351.923 0 1.41.068 1.641.1v1.844h-1.313c-.818 0-1.104.78-1.104 1.658v1.155h2.396l-.324 2.114h-2.07V20C16.987 19.468 20 16.112 20 12.041 20 7.601 16.418 4 12 4Z" }) }))); };
export default SvgFb;
